function pad(value: number): string {
  return String(value).padStart(2, "0");
}

export function formatTripDate(epochSeconds: number | undefined): string {
  if (epochSeconds === undefined) return "Unknown date";

  const date = new Date(epochSeconds * 1000);
  if (Number.isNaN(date.getTime())) return "Invalid date";

  return [
    date.getFullYear(),
    "-",
    pad(date.getMonth() + 1),
    "-",
    pad(date.getDate()),
    " ",
    pad(date.getHours()),
    ":",
    pad(date.getMinutes()),
    ":",
    pad(date.getSeconds()),
  ].join("");
}
